import type { CurrentRead } from '@signalvote/data';
import type { PreflightResult } from '@signalvote/shared';
import { Button } from '@/components/ui/button';
import { useRefreshFilingPreflight } from '@/hooks/queries';

/**
 * Says a report's filing checks could not be loaded, with Retry, so an empty blocker or warning
 * list is never read as "nothing blocks". Renders nothing while the read is loading, idle or ready.
 */
export function PreflightUnready({
  read,
  reportId,
}: {
  read: CurrentRead<PreflightResult | null>;
  reportId: string | null;
}) {
  const refresh = useRefreshFilingPreflight();
  if (read.status !== 'failed' && read.status !== 'offline') return null;

  return (
    <div
      role="alert"
      data-testid="preflight-unready"
      className="flex flex-wrap items-center gap-2 text-sm text-destructive"
    >
      <span>
        {read.status === 'offline'
          ? "You're offline, so we couldn't check this report's filing readiness."
          : "We couldn't check this report's filing readiness."}
      </span>
      {reportId && (
        <Button type="button" size="sm" variant="outline" onClick={() => void refresh(reportId)}>
          Retry
        </Button>
      )}
    </div>
  );
}
